import _ from 'lodash';
import postal from 'postal';

const editorValidate = (self, componentName, { channel = 'editor', topic = 'validate' } = {}) => {
  const editor = postal.channel(channel);

  editor.subscribe(topic, () => {
    if (self.validator && self.state) {
      const validations = self.validator.validateForm(self.state);
      if (self.state.validations) {
        self.setState({ validations });
      }
      editor.publish(`field.${componentName}.validated`, { isValid: validations.formValid });
    }
  });
};

const fValidTopics = { channel: 'editor', topic: 'field.*.validated' };

const whenAllValid = ({
  fields, action, done, timeout = 2000,
} = {}) => {
  const markers = _.reduce(fields, (r, d) => _.set(r, d, false), {});
  const subscriptions = postal.subscribe({
    ...fValidTopics,
    callback: (data, envelope) => {
      postal.unsubscribeFor(envelope);
      const fName = _.nth(envelope.topic.match(/^field\.(.*)\.validated$/), 1);
      if (!fName) {
        return;
      }
      markers[fName] = data;
      if (_.every(markers, 'isValid')) {
        postal.unsubscribe(fValidTopics);
        done();
      }
    },
  });
  action();
  setTimeout(() => subscriptions.unsubscribe(), timeout);
};

export {
  editorValidate,
  whenAllValid,
};
